module.exports = __webpack_public_path__ + "img/pop-up-vn-2.c2b36dae.png";